import React, { HTMLAttributes, useState } from 'react'
import { usePopper } from 'react-popper'

interface PopperTooltipProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  title?: string
  message?: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
  className?: string
  triggerClassname?: string
}

const PopperTooltip = ({
  title,
  message,
  placement = 'top',
  triggerClassname,
  className,
  children,
  ...rest
}: PopperTooltipProps) => {
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null)
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null)
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement,
  })

  const showTooltip = () => {
    popperElement?.setAttribute('data-show', 'true')
  }

  const hideTooltip = () => {
    popperElement?.removeAttribute('data-show')
  }

  return (
    <>
      <button
        type="button"
        className={`popper-tooltip-trigger ${triggerClassname}}`}
        ref={setReferenceElement}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        {children}
      </button>

      <div
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
        className={`popper-tooltip ${className}`}
        {...rest}
      >
        <h4 className="popper-tooltip-title ">{title}</h4>
        <p className="popper-tooltip-message"> {message}</p>
      </div>
    </>
  )
}

export default PopperTooltip
